import React from 'react';
import { motion } from 'framer-motion';
import { useSelector, useDispatch } from 'react-redux';
import { RootState } from '../../store';
import { authService } from '../../services/auth';
import { logout } from '../../store/slices/authSlice';
import Button from '../common/Button';
import { ASSET_PATHS } from '../../utils/gameConfig';

const InactiveInstructorScreen: React.FC = () => {
  const dispatch = useDispatch();
  const { user } = useSelector((state: RootState) => state.auth);

  const handleLogout = async () => {
    try {
      await authService.signOut();
      dispatch(logout());
    } catch (error) {
      console.error('Error signing out:', error);
    }
  };

  const handleRefresh = () => {
    //Refresh the page to check if account has been activated
    window.location.reload();
  };

  return (
    <div 
      className="min-h-screen flex items-center justify-center p-6"
      style={{
        backgroundImage: `url(${ASSET_PATHS.BACKGROUNDS.MODAL})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
      }}
    >
      <motion.div
        initial={{ opacity: 0, scale: 0.95 }}
        animate={{ opacity: 1, scale: 1 }}
        className="bg-white/95 backdrop-blur-sm rounded-2xl shadow-2xl border border-powder-200 p-8 max-w-md w-full text-center"
      >
        {/* Pending Icon */}
        <div className="text-6xl mb-6">⏳</div>
        
        <h1 className="text-2xl font-bold text-powder-800 mb-4">
          Account Pending Approval
        </h1>
        
        <div className="text-powder-600 mb-6 space-y-3">
          <p>
            Hi {user?.firstName}! Your instructor account is currently pending approval.
          </p>
          <p>
            If you recently registered as an instructor, please check back in a bit to see if your account has been activated.
          </p>
          <p>
            You'll receive an email notification once your account is approved.
          </p>
        </div>

        {/* Account Info */}
        <div className="bg-powder-50 rounded-lg p-4 mb-6">
          <div className="text-sm text-powder-600 mb-1">Account Email</div>
          <div className="font-medium text-powder-800">{user?.email}</div>
        </div>

        {/* Action Buttons */}
        <div className="space-y-3">
          <Button
            variant="primary"
            fullWidth
            onClick={handleRefresh}
          >
            Check Status Again
          </Button>
          
          <Button
            variant="outline"
            fullWidth
            onClick={handleLogout}
          >
            Log Out
          </Button>
        </div>

        {/* Help Text */}
        <div className="mt-6 pt-4 border-t border-powder-200">
          <p className="text-xs text-powder-500">
            Need help? Contact your system administrator about instructor account approval.
          </p>
        </div>
      </motion.div>
    </div>
  );
};

export default InactiveInstructorScreen;